/**
 * /frontend/src/features/analytics/components/shared/KPICard.js
 */

import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';
import './KPICard.css';

/**
 * KPI display card.
 * @param {{label:string,value:string,subLabel?:string,trend?:string,trendTone?:'good'|'bad'|'neutral',valueTone?:'default'|'green'}} props
 * @returns {JSX.Element}
 */
const TREND_ARROW = { good: <TrendingUp size={12} />, bad: <TrendingDown size={12} />, neutral: null };

const KPICard = ({ label, value, subLabel, trend, trendTone = 'neutral', valueTone = 'default' }) => (
  <article className="analytics-kpi-card">
    <p className="analytics-kpi-label">{label}</p>
    <h3 className={`analytics-kpi-value${valueTone === 'green' ? ' green' : ''}`}>{value}</h3>
    {subLabel ? <p className="analytics-kpi-sublabel">{subLabel}</p> : null}
    {trend ? (
      <p className={`analytics-kpi-trend tone-${trendTone}`}>
        {TREND_ARROW[trendTone] !== null ? (
          <span className="analytics-kpi-trend-arrow" aria-hidden="true">{TREND_ARROW[trendTone]}</span>
        ) : null}
        {trend}
      </p>
    ) : null}
  </article>
);

export default KPICard;
